const SETTINGS = {
  baseUrl: 'https://www.dsimmobiliare.net',
  baseUrlBackend: 'https://admin.dsimmobiliare.net',
  baseUrlBackendApi: 'https://admin.dsimmobiliare.net/api',
  pageSize: 16
}

export { SETTINGS };
